import { FilterOperator } from '@progress/kendo-data-query';
import { GridColumnMenuProps } from '@progress/kendo-react-grid';
import { Checkbox } from '@progress/kendo-react-inputs';

export function NotesColumnFilters(props: GridColumnMenuProps) {
    const checked = props.filter?.filters.some((x) => 'field' in x && x.field === props.column.id);
    return (
        <div className="px-2">
            <Checkbox
                label="Has notes"
                checked={checked}
                onChange={(e) => {
                    if (e.value) {
                        if (props.filter) {
                            props.onFilterChange?.(
                                {
                                    ...props.filter,
                                    filters: [
                                        ...props.filter.filters,
                                        {
                                            field: props.column.field,
                                            operator: FilterOperator.EqualTo,
                                            value: true
                                        }
                                    ]
                                },
                                e.syntheticEvent
                            );
                        } else {
                            props.onFilterChange?.(
                                {
                                    filters: [
                                        {
                                            field: props.column.field,
                                            operator: FilterOperator.EqualTo,
                                            value: true
                                        }
                                    ],
                                    logic: 'and'
                                },
                                e.syntheticEvent
                            );
                        }
                    } else {
                        if (props.filter) {
                            props.onFilterChange?.(
                                {
                                    ...props.filter,
                                    filters: props.filter.filters.filter((x) => ('field' in x ? x.field !== props.column.id : true))
                                },
                                e.syntheticEvent
                            );
                        } else {
                            props.onFilterChange?.(null, e.syntheticEvent);
                        }
                    }
                }}
            />
        </div>
    );
}
